import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class OffcanvasController extends Controller {
  connect() {
    this.initializeOffcanvas();

    document.addEventListener(
      "turbo:before-cache",
      this.handleBeforeCache
    );
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-cache",
      this.handleBeforeCache
    );

    this.disposeOffcanvas();
  }

  initializeOffcanvas() {
    this.offcanvas = bootstrap.Offcanvas.getOrCreateInstance(
      this.element
    );
  }

  open() {
    this.element.classList.remove("d-none");

    this.initializeOffcanvas();
    this.offcanvas.show();
  }

  close() {
    this.offcanvas?.hide();
  }

  handleBeforeCache = () => {
    this.disposeOffcanvas();
  };

  disposeOffcanvas() {
    if (this.offcanvas) {
      this.offcanvas.hide();
      this.offcanvas.dispose();
      this.offcanvas = null;
    }

    for (const backdrop of document
      .querySelectorAll(".offcanvas-backdrop")) backdrop.remove();

    document.body.classList.remove("offcanvas-backdrop");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");

    this.element.classList.remove("show");
    this.element.setAttribute("aria-hidden", "true");
    this.element.removeAttribute("aria-modal");
    this.element.removeAttribute("role");
  }
}

